import React from 'react';
import sanitizer from '@helpers/sanitizer';
import { ContentsPageMetadata } from '@interfaces/models/contentsPageMetadata';
import styles from './seo-footer.module.scss';

export type SEOFooterProps = {
  title: ContentsPageMetadata['title'];
  body: ContentsPageMetadata['description'];
};

const SEOFooter: React.FC<SEOFooterProps> = (props): React.JSX.Element => {
  const { title, body } = props;

  return (
    <article className={styles['seo-footer']}>
      <div className={styles['seo-footer__headline']}>{title}</div>
      <div
        className={styles['seo-footer__description']}
        dangerouslySetInnerHTML={{ __html: sanitizer(body) }}
      />
    </article>
  );
};

export default SEOFooter;
